module.exports = __webpack_public_path__ + "static/media/iota.330c4639.png";